"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachFile = void 0;
const react_1 = __importDefault(require("react"));
const ComposeContext_1 = require("../ComposeContext");
const AttachFile = ({ disableInputs, onAttach }) => {
    const { uploadFileFunction, maxAllowedFileSize, allowedFileExtensions, uploadedFiles, setUploadedFiles, setIsUploadingFile, uploadingFileErrors, setUploadingFileErrors, } = (0, ComposeContext_1.useCompose)();
    // If for some reason state setters aren't passed in, then we won't run functionality
    // But they're passed in the <Compose> component so definitely should be!
    const hasAllStateSetters = uploadFileFunction !== undefined &&
        setUploadedFiles !== undefined &&
        setIsUploadingFile !== undefined &&
        setUploadingFileErrors !== undefined;
    const uploadFile = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (!hasAllStateSetters) {
            return;
        }
        if (e.target.files !== null) {
            setIsUploadingFile === null || setIsUploadingFile === void 0 ? void 0 : setIsUploadingFile(true);
            const files = Array.from(e.target.files);
            for (const file of files) {
                const isValid = validateFile(file);
                if (isValid) {
                    const dataUrl = yield readFile(file);
                    const request = {
                        file: file,
                    };
                    setUploadingFileErrors === null || setUploadingFileErrors === void 0 ? void 0 : setUploadingFileErrors([]);
                    const response = yield (uploadFileFunction === null || uploadFileFunction === void 0 ? void 0 : uploadFileFunction({ request }));
                    if ((response === null || response === void 0 ? void 0 : response.success) && (response === null || response === void 0 ? void 0 : response.attachmentId)) {
                        setUploadedFiles === null || setUploadedFiles === void 0 ? void 0 : setUploadedFiles([
                            ...uploadedFiles,
                            {
                                file: file,
                                attachmentId: response.attachmentId,
                                dataUrl: dataUrl,
                            },
                        ]);
                    }
                    else {
                        setUploadingFileErrors === null || setUploadingFileErrors === void 0 ? void 0 : setUploadingFileErrors([
                            ...uploadingFileErrors,
                            "Sorry something went wrong uploading this file",
                        ]);
                    }
                    setIsUploadingFile === null || setIsUploadingFile === void 0 ? void 0 : setIsUploadingFile(false);
                }
                else {
                    setIsUploadingFile === null || setIsUploadingFile === void 0 ? void 0 : setIsUploadingFile(false);
                }
            }
        }
        // If we shut the modal without uploading anything then also need to re-enable the "attach file" button here
        setIsUploadingFile === null || setIsUploadingFile === void 0 ? void 0 : setIsUploadingFile(false);
        onAttach && onAttach();
    });
    const readFile = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            // Read the file via FileReader API and save file result in state.
            reader.onload = function (e) {
                var _a;
                // Add the file name to the data URL
                const dataURL = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
                const result = dataURL.replace(";base64", `;name=${file.name};base64`);
                resolve(result);
            };
            reader.readAsDataURL(file);
        });
    };
    const validateFile = (file) => {
        if (!hasAllStateSetters) {
            return;
        }
        const failureReasons = [];
        let success = false;
        try {
            if (file.size === 0) {
                failureReasons.push("Cannot upload an empty file");
            }
            if (file.size > maxAllowedFileSize.size) {
                failureReasons.push("File too big, max file size: " +
                    maxAllowedFileSize.humanReadable);
            }
            const fileExtension = file.name.split(".").pop().toLowerCase();
            if (allowedFileExtensions.indexOf(fileExtension) === -1) {
                failureReasons.push(`Unsupported file extension: File with the extension .${fileExtension} was encountered, but files can only be one of the supported extensions (${allowedFileExtensions.join(", ")})`);
            }
            success = failureReasons.length === 0;
        }
        catch (e) {
            failureReasons.push("Error validating file");
            success = false;
        }
        setUploadingFileErrors === null || setUploadingFileErrors === void 0 ? void 0 : setUploadingFileErrors([...uploadingFileErrors, ...failureReasons]);
        return success;
    };
    return (react_1.default.createElement("input", { type: "file", accept: `.${allowedFileExtensions.join(",.")}`, id: "fileUpload", "data-testid": "fileUpload", onChange: uploadFile, 
        // Need to reset this on click in case we want to upload the same file twice
        onClick: (event) => {
            event.currentTarget.value = "";
        }, style: { display: "none" }, disabled: disableInputs }));
};
exports.AttachFile = AttachFile;
//# sourceMappingURL=AttachFile.js.map